import "./_style.scss";
import { useContext, useEffect, useRef, useState } from "react";
import TkStepper from "../../components/atoms/TkStepper";
import TkFakeTableLine from "../../components/atoms/TkFakeTableLine";
import TkBackButton from "../../components/molecules/TkBackButton";
import TkFakeTable from "../../components/molecules/TkFakeTable";
import { Box } from "@mui/material";
import TkMessageDialog from "../../components/molecules/TkMessageDialog";
import TkInfoManual from "../../components/atoms/TkInfoManual";
import TkContractorAndNumberLine from "../../components/molecules/TkContractorAndNumberLine";
import TkDateDialog from "../../components/molecules/TkDateDialog";
import { IAPI_CON014_Request } from "../../type/apiType";
import authorityUserType from "../../assets/data/TkAuthorityProperty";
import { GlobalContext } from "../../context/globalContext";
import { fakeTableList, schema, stepperData } from "./parts";
import { BusinessContext } from "../../context/businessContext";
import { useNavigate } from "react-router";
import { httpIAPI_CON014, httpIAPI_CON023 } from "./api/request";
import { labelids } from "../../assets/data/TkExplanationProperty";
import { useLocation } from "react-router-dom";
import _ from "lodash";

/**
 * SCRC050012 契約解除（中退共済契約締結）入力内容確認
 * @return SCRC050012 契約解除（中退共済契約締結）入力内容確認
 */

const SCRC050012 = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [disabled, setDisabled] = useState(true);
  const { state, setState } = useContext(GlobalContext);
  const [stateTableList, setStateTableList] = useState<any>([]);
  const stateFakeTableList = useRef(_.cloneDeep(fakeTableList));
  const { state: businessState } = useContext<any>(BusinessContext);
  const [openSubmit, setOpenSubmit] = useState(false);
  const [httpReq, setHttpReq] = useState<IAPI_CON014_Request>({
    applyId: 0,
    tempSaveStep: 0,
    contractorNo: "",
    contractDate: "",
    contractNo: "",
    contractReason: "",
    remark: "",
    receptionDate: "",
    screenId: "",
  });
  const [dataTemp, setdataTemp] = useState<IAPI_CON014_Request>({
    tempSaveStep: 0,
    contractDate: "",
    contractNo: "",
    contractReason: "",
    remark: "",
  });
  const [status, setStatus] = useState(true);

  const userType = state.authInfo?.userType;
  const isKiko = userType === authorityUserType.userTypeNumber.KIKO;
  const contractorNo = isKiko
    ? businessState.common?.contractorNo
    : state.authInfo?.contractorNo!;
  const applyId = location.state?.applyId ?? businessState?.job_03?.applyId;

  // 初期化
  const handleInit = async () => {
    try {
      let resArr = stateFakeTableList.current;
      let res;
      let checkStatus = true;
      if (applyId) {
        res = await httpIAPI_CON023({
          applyId: applyId,
          contractorNo,
        });
        resArr.find((item) => item.keyword === "contractNo")!.text =
          res?.contractNo;
        if (res.resultCd !== "I0000") {
          setState({
            ...state,
            errorMsgId: res.resultCd,
          });
          return;
        }
        checkStatus =
          res?.latestApplyStatus === "00" ||
          res?.latestApplyStatus === "16" ||
          res?.latestApplyStatus === null;
        setStatus(checkStatus);
      } else {
        res = location?.state;
        resArr.find((item) => item.keyword === "contractNo")!.text =
          res?.contractNo;
      }

      resArr.find((item) => item.keyword === "contractDate")!.text =
        res?.contractDate;

      resArr.find((item) => item.keyword === "contractReason")!.text =
        res?.contractReason;

      resArr.find((item) => item.keyword === "remark")!.text = res?.remark;

      let employeeStatusCheckboxIndex = resArr.find(
        (item) => item.keyword === "employeeStatusCheckbox"
      )!;

      employeeStatusCheckboxIndex.node = (
        <Box className="SCRC050012checkboxGroup">
          <TkFakeTableLine
            title="従業状況は最新の状況になっていますか？"
            type="checkboxGroup"
            checkBoxList={[
              {
                label: "はい",
                disabled: !checkStatus,
              },
            ]}
            setDefaultValue={!checkStatus ? "はい" : ""}
            onChange={handleCheckboxChange}
          />
        </Box>
      );

      const data: IAPI_CON014_Request = {
        tempSaveStep: res.tempSaveStep,
        contractDate: res.contractDate,
        contractNo: res.contractNo,
        contractReason: res.contractReason,
        remark: res.remark,
      };
      setdataTemp(data);
      setStateTableList([...resArr]);
      setState({
        ...state,
        errorMsgId: "",
      });
    } catch (error) {
      navigate("/error");
    }
  };

  useEffect(() => {
    handleInit();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleOk = async (date?: any) => {
    //中小企業退職金共済契約締結届更新API実行
    try {
      const res = await httpIAPI_CON014({
        ...httpReq,
        receptionDate: date,
      });
      if (res.resultCd === "I0000") {
        setState({
          ...state,
          errorMsgId: "",
        });
        navigate("/SCRC070008");
      } else {
        setState({
          ...state,
          errorMsgId: res.resultCd,
        });
        setOpenSubmit(false);
      }
    } catch (error) {
      navigate("/error");
    }
  };

  const onCheckAndSubmit = () => {
    setHttpReq({ ...makeHttpObj(dataTemp) });
    setOpenSubmit(true);
  };

  const makeHttpObj = (dataTemp: IAPI_CON014_Request) => {
    const reqObj: IAPI_CON014_Request = {
      //申請id
      applyId: applyId,
      //一時保存ステップ
      tempSaveStep: null,
      //共済契約者番号
      contractorNo: isKiko
        ? businessState.common?.contractorNo!
        : state.authInfo?.contractorNo!,
      //中小企業退職共済契約締結年月日
      contractDate: dataTemp.contractDate,
      //中小企業退職共済契約者番号
      contractNo: dataTemp.contractNo,
      //中小企業退職共済契約締結の理由
      contractReason: dataTemp.contractReason,
      //備考
      remark: dataTemp.remark,
      //画面id
      screenId: "SCRC050012",
    };

    return reqObj;
  };

  const handleCheckboxChange = (newCheckBoxState: any[]) => {
    if (newCheckBoxState && newCheckBoxState.includes("はい")) {
      setDisabled(false);
    } else {
      setDisabled(true);
    }
  };

  return (
    <Box className="SCRC050012" data-testid="SCRC050012PageForTest">
      <TkStepper
        steps={stepperData}
        activeStep={status ? 1 : 2}
        savaStep={httpReq.tempSaveStep! - 1}
      />
      <TkInfoManual rule={"\\n"}>{labelids.labelid.LBLC050012_01}</TkInfoManual>

      {isKiko && (
        <TkContractorAndNumberLine
          name="契約者（法人）名"
          no={
            businessState?.common?.contractorNo +
            ":" +
            businessState?.common?.contractorName
          }
        />
      )}

      <TkFakeTable
        list={stateTableList}
        ruleSchema={schema}
        submitButtonText={isKiko ? "申請" : "機構へ提出する"}
        showButton={status}
        disabled={disabled}
        buttonGroup={<TkBackButton />}
        onCheckAndSubmit={onCheckAndSubmit}
      />

      {isKiko ? (
        <TkDateDialog
          open={openSubmit}
          onOky={handleOk}
          onCancel={() => setOpenSubmit(false)}
          minDate={new Date("1900/01/01")}
          maxDate={new Date()}
          title="確認（申請）"
          contextText="　申請を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      ) : (
        <TkMessageDialog
          open={openSubmit}
          onOky={handleOk}
          onCancel={() => setOpenSubmit(false)}
          title="確認（機構へ提出する）"
          contextText="　機構へ提出を行いますが、問題ないでしょうか。"
          cancelText="いいえ"
          okText="はい"
        />
      )}
    </Box>
  );
};

export default SCRC050012;
